import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { url } from "../../../Constant";
import DateTimeRange from "../../../components/common/DateTimeRange";
import { toast } from "react-toastify";
import moment from "moment";
import $ from "jquery";
import { useAuth } from "../../../Context/AuthProvider";

const EditDetailForm = () => {
  const { auth } = useAuth();
  const [companies, setCompanies] = useState();
  const [company, setCompany] = useState();
  const [loader, setLoader] = useState(false);
  const [errorEnable, setErrorEnable] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [pwdPassword, setPwdPassword] = useState("valid");
  const [mobileNumberError, setMobileNumberError] = useState("");
  const [workNumberError, setWorkNumberError] = useState("");
  const [fileUploadError, setFileUploadError] = useState("");
  const [userNameError, setUserNameError] = useState("");
  const [passwordRequired, setPasswordRequired] = useState(false);
  const [cnfrmPasswordRequired, setCnfrmPasswordRequired] = useState(false);
  const [isDateTimePickerVisible, setIsDateTimePickerVisible] = useState(false);
  const [submittedData, setSubmittedData] = useState({
    company_name: "",
    ntn: "",
    nature_of_companies: "",
    address: "",
    user_name: "",
    email: "",
    work_number: "",
    mobile_number: "",
    password: "",
    password_confirm: "",
    diodid: "",
    package_id: "",
    inbound_recording: "",
    outbound_recording: "",
    extension_recording: "",
    package_activation_datetime: "",
    package_inactivation_datetime: "",
    extensionfile: "",
  });

  const getCompanies = () => {
    axios
      .post(
        url + "get-companies",
        {
          // vpbx_id: sessionStorage.getItem("companyData"),
          // vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            if (response.data.message === "Data Found") {
              setCompanies(response.data.data.companies);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  const getCompany = () => {
    axios
      .post(
        url + "create-company",
        {
          // vpbx_id: sessionStorage.getItem("companyData"),
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            if (
              response.data.message === "Data Not Found" &&
              response.data.data.length === 0
            ) {
              setCompany([]);
            } else if (response.data.message === "Data Found") {
              setCompany(response.data.data);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  useEffect(() => {
    getCompanies();
    getCompany();
  }, []);
  useEffect(() => {
    if (companies !== undefined) {
      let filtercompanies = companies?.filter((val) => {
        return val.vpbx_id == sessionStorage.getItem("companyData");
      });
      if (filtercompanies.length > 0) {
        setSubmittedData({
          company_name: filtercompanies[0]?.company_name,
          ntn: filtercompanies[0]?.ntn,
          nature_of_companies: filtercompanies[0]?.nature_of_company,
          address: filtercompanies[0]?.address,
          user_name: filtercompanies[0]?.user_name,
          email: filtercompanies[0]?.email,
          work_number: filtercompanies[0]?.work_number,
          mobile_number: filtercompanies[0]?.mobile_number,
          password: "",
          password_confirm: "",
          diodid: filtercompanies[0]?.diodid,
          package_id: filtercompanies[0]?.package_id,
          inbound_recording: filtercompanies[0]?.inbound_recording,
          outbound_recording: filtercompanies[0]?.outbound_recording,
          extension_recording: filtercompanies[0]?.extension_recording,
          // package_activation_datetime: filtercompanies[0]?.package_activation_datetime,
          // package_inactivation_datetime: filtercompanies[0]?.,
          package_activation_datetime: "",
          package_inactivation_datetime: "",
          extensionfile: "",
        });

        setStartDate(
          moment(
            filtercompanies[0]?.package_inactivation_datetime.split(" ")[0]
          ).format("MM-DD-YYYY")
        );
        setEndDate(
          moment(
            filtercompanies[0]?.package_activation_datetime.split(" ")[0]
          ).format("MM-DD-YYYY")
        );
        setEmailError("Valid Email Address");
      }
    }
  }, [companies]);
  const ValidateEmail = (value) => {
    var mailformat = /^[A-Za-z][\w$.]+@[\w]+\.\w+$/;
    if (mailformat.test(value)) {
      return "Valid Email";
    } else {
      return "Invalid Email";
    }
  };
  const handleConfirmPwdValidation = (e) => {
    if (e === submittedData.password && e.length >= 5) {
      setPwdPassword("valid");
    } else {
      setPwdPassword("invalid");
    }

    if (submittedData.password !== "") {
      setPasswordRequired(false);
    } else {
      setPasswordRequired(true);
    }
    if (e === "") {
      setCnfrmPasswordRequired(true);
    }
    if (e !== "") {
      setCnfrmPasswordRequired(false);
    }

    if (e === "" && submittedData.password === "") {
      setPasswordRequired(false);
      setCnfrmPasswordRequired(false);
      setPwdPassword("valid");
    }
  };
  const handlePasswordValidation = (e) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{1,}$/;
    let testedPassword = passwordRegex.test(e);

    if (testedPassword === false) {
      setPasswordError("Validation error");
    } else if (e.length < 14) {
      setPasswordError("Invalid password");
    } else {
      setPasswordError("");
    }
    if (submittedData.password_confirm !== "") {
      setCnfrmPasswordRequired(false);
    } else {
      setCnfrmPasswordRequired(true);
    }
    if (e === "") {
      setPasswordRequired(true);
    }

    if (e === submittedData.password_confirm) {
      setPwdPassword("valid");
    } else {
      setPwdPassword("invalid");
    }

    if (e === "") {
      setPasswordRequired(true);
    }
    if (e !== "") {
      setPasswordRequired(false);
    }

    if (e === "" && submittedData.password_confirm === "") {
      setPasswordRequired(false);
      setCnfrmPasswordRequired(false);
      setPasswordError("");
    }
  };
  const userNamValidation = (e) => {
    if (e.length < 5) {
      setUserNameError("Invalid user");
    } else {
      setUserNameError("");
    }
  };
  const handleEmailValidation = (e) => {
    var Email = ValidateEmail(e);
    if (Email === "Invalid Email") {
      setEmailError("Invalid Email Address");
    } else {
      setEmailError("Valid Email Address");
    }
  };
  const handleMobileNumberValidation = (e) => {
    if (e.length !== 11) {
      setMobileNumberError("Invalid mobile number");
    } else {
      setMobileNumberError("");
    }
  };
  const handleWorkNumberValidation = (e) => {
    if (e.length !== 11) {
      setWorkNumberError("Invalid mobile number");
    } else {
      setWorkNumberError("");
    }
  };
  const handleFile = (e) => {
    var file = e.target.files[0];
    var fileName = e.target.files[0].name;
    let fileNameSplit = fileName.split(".");
    let fileExtensionName = fileNameSplit[1];
    if (fileExtensionName !== "csv") {
      setFileUploadError("Please upload csv format file");
      setSubmittedData({
        ...submittedData,
        extensionfile: "Invalid File",
      });
    } else {
      setFileUploadError("");
      setSubmittedData({
        ...submittedData,
        extensionfile: file,
      });
    }
  };

  const createCompany = (e) => {
    e.preventDefault();
    setErrorEnable(true);
    setLoader(true);

    var inbound_checkbox =
      $("#inbound_checkbox").is(":checked") === true ? 1 : 0;
    var outbound_checkbox =
      $("#outbound_checkbox").is(":checked") === true ? 1 : 0;
    var extension_checkbox =
      $("#extension_checkbox").is(":checked") === true ? 1 : 0;
    var formData = new FormData();
    formData.append("company_name", submittedData.company_name);
    formData.append("user_name", submittedData.user_name);
    formData.append("address", submittedData.user_name);
    formData.append("ntn", submittedData.ntn);
    formData.append("email", submittedData.email);
    formData.append("work_number", submittedData.work_number);
    formData.append("mobile_number", submittedData.mobile_number);
    formData.append("password", submittedData.password);
    formData.append("password_confirm", submittedData.password_confirm);
    formData.append("diodid", submittedData.diodid);
    formData.append("nature_of_companies", submittedData.nature_of_companies);
    formData.append("package_id", submittedData.package_id);
    formData.append("inbound_recording", inbound_checkbox);
    formData.append("outbound_recording", outbound_checkbox);
    formData.append("extension_recording", extension_checkbox);
    formData.append(
      "package_activation_datetime",
      startDate === "" ? "" : moment(startDate).format("YYYY-MM-DD")
    );
    formData.append(
      "package_inactivation_datetime",
      endDate === "" ? "" : moment(endDate).format("YYYY-MM-DD")
    );
    formData.append("extensionfile", submittedData.extensionfile);

    if (
      submittedData.company_name !== "" &&
      submittedData.ntn !== "" &&
      submittedData.nature_of_companies !== "" &&
      submittedData.address !== "" &&
      submittedData.user_name !== "" &&
      submittedData.work_number !== "" &&
      submittedData.mobile_number !== "" &&
      submittedData.email !== "" &&
      submittedData.diodid !== "" &&
      submittedData.package_id !== "" &&
      // submittedData.password !== "" &&
      // submittedData.password_confirm !== "" &&
      // submittedData.extensionfile !== "" &&
      // startDate !== "" &&
      // endDate !== "" &&
      emailError === "Valid Email Address" &&
      pwdPassword === "valid" &&
      passwordError === "" &&
      mobileNumberError === "" &&
      workNumberError === "" &&
      fileUploadError === "" &&
      userNameError === "" &&
      cnfrmPasswordRequired === false &&
      passwordRequired === false
    ) {
      axios
        .post(
          url + `update-company/${sessionStorage.getItem("companyData")}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
        )
        .then(
          (response) => {
            if (response.data.code === 200) {
              if (
                response.data.message === "Company user updated successfully."
              ) {
                setLoader(false);
                toast.success(response.data.message, {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1500,
                });
                setTimeout(() => {
                  window.location.href = "/vpbx-manager";
                }, 2000);
              }
            } else {
              if (
                response?.data?.data?.errors[0] ===
                "non integers are not allowed"
              ) {
                toast.error("Please upload correct file format", {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1500,
                });
                setLoader(false);
              } else {
                toast.error(response?.data?.data?.errors[0], {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1500,
                });
                setLoader(false);
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      setLoader(false);
    }
  };
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-small">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <Link to="/vpbx-manager">
                  <img src="./assets/images/zong/chevron--left.svg" uk-svg="" />
                  <span>Back to VPBX manager</span>
                </Link>
                <h3>COMPANY DETAILS</h3>
                <p>
                  Edit the details for the new company, change user information,
                  master number or package.
                </p>
              </div>
            </div>
            {/* <div className="uk-width-1-3">
              <div className="dashboardIntro uk-text-right">
                <button>EXPORT DATA</button>
              </div>
            </div> */}
          </div>

          <form onSubmit={createCompany}>
            <div className="formCreateMain">
              <div className="uk-grid uk-grid-small">
                <div className="uk-width-1-1@m uk-margin-top">
                  <legend className="uk-legend">Company information</legend>
                </div>
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Company name</label>
                  <input
                    className="uk-input"
                    type="text"
                    aria-label="Input"
                    placeholder="Company name"
                    defaultValue={submittedData?.company_name}
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        company_name: e.target.value,
                      });
                    }}
                  />
                  {errorEnable && submittedData.company_name === "" && (
                    <div className="formErrors">company is required</div>
                  )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>NTN/VAT/Tax ID</label>
                  <input
                    className="uk-input"
                    type="text"
                    aria-label="Input"
                    placeholder="Company NTN / VAT / Tax ID"
                    defaultValue={submittedData?.ntn}
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        ntn: e.target.value,
                      });
                    }}
                  />
                  {errorEnable && submittedData.ntn === "" && (
                    <div className="formErrors">ntn is required</div>
                  )}
                </div>
                {/* <div className="uk-width-1-2@m uk-margin-top">
                  <label>Password</label>
                  <input
                    className="uk-input"
                    type="password"
                    aria-label="Input"
                    placeholder="Enter Password"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        password: e.target.value,
                      });
                      handlePasswordValidation(e.target.value);
                    }}
                  />
                 
                  {errorEnable && passwordRequired === true && (
                    <div className="formErrors"> Password is required</div>
                  )}
                  {submittedData.password !== "" &&
                    errorEnable &&
                    passwordError === "Invalid password" && (
                      <div className="formErrors">
                        Password must be 14 characters{" "}
                      </div>
                    )}
                  {submittedData.password !== "" &&
                    errorEnable &&
                    passwordError === "Validation error" && (
                      <div className="formErrors">
                        Password must includes uppercase, lowercase, numbers and
                        special characters
                      </div>
                    )}
                </div>
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Confirm password</label>
                  <input
                    className="uk-input"
                    type="password"
                    aria-label="Input"
                    placeholder="Enter confirm password"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        password_confirm: e.target.value,
                      });
                      handleConfirmPwdValidation(e.target.value);
                    }}
                  />
                  
                  {errorEnable && cnfrmPasswordRequired === true && (
                    <div className="formErrors">
                      Confirm password is required
                    </div>
                  )}
                  {submittedData.password_confirm !== "" &&
                    errorEnable &&
                    pwdPassword === "invalid" && (
                      <div className="formErrors">
                        Password and confirm password not matched{" "}
                      </div>
                    )}
                </div> */}

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Nature of company</label>
                  <select
                    className="uk-select"
                    aria-label="Select"
                    // defaultValue={submittedData?.nature_of_companies}
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        nature_of_companies: e.target.value,
                      });
                    }}
                  >
                    <option value="" selected>
                      Select company type...
                    </option>
                    {company?.nature_of_companies?.map((val, index) => {
                      return (
                        <option
                          key={index}
                          value={val.id}
                          selected={
                            submittedData?.nature_of_companies === val.id
                          }
                        >
                          {val.title}
                        </option>
                      );
                    })}
                  </select>
                  {errorEnable && submittedData.nature_of_companies === "" && (
                    <div className="formErrors">
                      Please select nature of caompany
                    </div>
                  )}
                </div>

                <div className="uk-width-1-1@m uk-margin-top">
                  <label>Address</label>
                  <textarea
                    className="uk-textarea"
                    rows="2"
                    aria-label="Textarea"
                    defaultValue={submittedData?.address}
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        address: e.target.value,
                      });
                    }}
                    placeholder="Address...................."
                  ></textarea>
                  {errorEnable && submittedData.address === "" && (
                    <div className="formErrors">Address is required</div>
                  )}
                </div>

                {/* user info start */}

                <div className="uk-width-1-1@m uk-margin-large-top">
                  <legend className="uk-legend">User information</legend>
                </div>
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Name</label>
                  <input
                    className="uk-input"
                    type="text"
                    aria-label="Input"
                    placeholder="User's name"
                    defaultValue={submittedData?.user_name}
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        user_name: e.target.value,
                      });
                      userNamValidation(e.target.value);
                    }}
                  />
                  {errorEnable && submittedData.user_name === "" && (
                    <div className="formErrors">Name is required</div>
                  )}
                  {errorEnable &&
                    submittedData.user_name !== "" &&
                    userNameError !== "" && (
                      <div className="formErrors">
                        User name must be alleast 5 characters long{" "}
                      </div>
                    )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Work number</label>
                  <input
                    className="uk-input"
                    type="text"
                    aria-label="Input"
                    placeholder="User's work number"
                    defaultValue={submittedData?.work_number}
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        work_number: e.target.value,
                      });
                      handleWorkNumberValidation(e.target.value);
                    }}
                  />
                  {errorEnable && submittedData.work_number === "" && (
                    <div className="formErrors">Work number is required</div>
                  )}
                  {submittedData.work_number !== "" &&
                    errorEnable &&
                    workNumberError === "Invalid mobile number" && (
                      <div className="formErrors">
                        Work number must be 11 charcters long
                      </div>
                    )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Mobile number</label>
                  <input
                    className="uk-input"
                    type="text"
                    aria-label="Input"
                    placeholder="User's mobile number"
                    defaultValue={submittedData?.mobile_number}
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        mobile_number: e.target.value,
                      });
                      handleMobileNumberValidation(e.target.value);
                    }}
                  />
                  {errorEnable && submittedData.mobile_number === "" && (
                    <div className="formErrors">Mobile number is required</div>
                  )}
                  {submittedData.mobile_number !== "" &&
                    errorEnable &&
                    mobileNumberError === "Invalid mobile number" && (
                      <div className="formErrors">
                        Mobile number must be 11 charcters long
                      </div>
                    )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Email</label>
                  <input
                    className="uk-input"
                    type="text"
                    aria-label="Input"
                    placeholder="User's email address"
                    defaultValue={submittedData?.email}
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        email: e.target.value,
                      });
                      handleEmailValidation(e.target.value);
                    }}
                  />
                  {errorEnable && submittedData.email === "" && (
                    <div className="formErrors">Email is required</div>
                  )}
                  {submittedData.email !== "" &&
                    errorEnable &&
                    emailError !== "Valid Email Address" && (
                      <div className="formErrors">Invalid Email Address</div>
                    )}
                </div>

                {/* package info start */}

                <div className="uk-width-1-1@m uk-margin-large-top">
                  <legend className="uk-legend">Package information</legend>
                </div>
                <div className="uk-width-1-2@m uk-margin">
                  <label>Package/Bucket Activation Date Range</label>
                  <div>
                    {/* Conditionally render the DateTimeRange based on isDateTimePickerVisible */}
                    {isDateTimePickerVisible ? (
                      <DateTimeRange
                        setStartDate={setStartDate}
                        setEndDate={setEndDate}
                      />
                    ) : (
                      <input
                        className="uk-input"
                        type="text"
                        aria-label="Input"
                        value={` ${startDate} - ${endDate} `}
                        readOnly
                        onClick={() => setIsDateTimePickerVisible(true)} // Show DateTimeRange when input is clicked
                      />
                    )}
                  </div>
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Master No. DIOD</label>

                  <input
                    className="uk-input"
                    type="text"
                    aria-label="Input"
                    placeholder="User's email address"
                    defaultValue={submittedData?.diodid}
                    disabled
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        diodid: e.target.value,
                      });
                    }}
                  />
                  {/* <select
                    className="uk-select"
                    aria-label="Select"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        diodid: e.target.value,
                      });
                    }}
                  >
                    <option value="" selected>
                      Select master no...
                    </option>
                    {company?.package_diod?.map((val, index) => {
                      return (
                        <option
                          key={index}
                          value={val.diod}
                          selected={submittedData?.diodid === val.diod}
                        >
                          {val.diod}
                        </option>
                      );
                    })}
                  </select> */}

                  {errorEnable && submittedData.diodid === "" && (
                    <div className="formErrors">Please select master no</div>
                  )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Package</label>
                  <select
                    className="uk-select"
                    aria-label="Select"
                    // defaultValue={submittedData?.package_id}
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        package_id: e.target.value,
                      });
                    }}
                  >
                    <option value="" selected>
                      Select package...
                    </option>
                    {company?.package_drop_down?.map((val, index) => {
                      return (
                        <option
                          key={index}
                          value={val.package_id}
                          selected={
                            submittedData?.package_id === val.package_id
                          }
                        >
                          {val.name}
                        </option>
                      );
                    })}
                  </select>

                  {errorEnable && submittedData.package_id === "" && (
                    <div className="formErrors">Please select package</div>
                  )}
                </div>

                {/* <div className="uk-width-1-1@m uk-margin">
                  <label>
                    <b>Voice Recording</b>
                  </label>
                  <label className="CheckBoxLabel">
                    <input
                      className="uk-checkbox"
                      type="checkbox"
                      id="inbound_checkbox"
                      checked={
                        submittedData?.inbound_recording === "1" ? true : false
                      }
                    />{" "}
                    <span>Inbound</span>
                  </label>

                  <label className="CheckBoxLabel">
                    <input
                      className="uk-checkbox"
                      type="checkbox"
                      id="outbound_checkbox"
                      checked={
                        submittedData?.outbound_recording === "1" ? true : false
                      }
                    />{" "}
                    <span>Outbound</span>
                  </label>

                  <label className="CheckBoxLabel">
                    <input
                      className="uk-checkbox"
                      type="checkbox"
                      id="extension_checkbox"
                      checked={
                        submittedData?.extension_recording === "1"
                          ? true
                          : false
                      }
                    />{" "}
                    <span>Extension</span>
                  </label>
                </div> */}
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>
                    <b>Please Select Any One Flow Extensions(File input)</b>
                  </label>

                  <div className="uk-margin-bottom">
                    <div uk-form-custom="target: true">
                      <input
                        type="file"
                        aria-label="Custom controls"
                        accept=".csv"
                        onChange={(e) => handleFile(e)}
                      />
                      <input
                        className="uk-input uk-form-width-medium"
                        type="text"
                        placeholder="Choose files"
                        aria-label="Custom controls"
                        disabled
                      />

                      {errorEnable && fileUploadError !== "" && (
                        <div className="formErrors">{fileUploadError}</div>
                      )}
                    </div>
                  </div>
                  <a
                    href={
                      "https://cap.zong.com.pk:8444/vpbx-apis/usr_sounds/extensions_sample.csv"
                    }
                    className="DownloadFileBtn"
                  >
                    Download sample file
                  </a>
                </div>
                <div className="uk-width-1-1@m uk-float-right">
                  <div className="formActionBtn uk-text-right">
                    {/* <button className="whiteBtn">Cancel</button> */}
                    <button className="pinkBtn" type="submit">
                      {loader ? (
                        <div uk-spinner="" className="loader">
                          Adding
                        </div>
                      ) : (
                        " Edit company"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
          {/* <form>
            <div className="formCreateMain">
              <div className="uk-grid uk-grid-small">
                <div className="uk-width-1-1@m uk-margin-top">
                  <legend className="uk-legend">Company information</legend>
                </div>
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Company name</label>
                  <input
                    className="uk-input"
                    type="text"
                    placeholder="Company name"
                    aria-label="Input"
                  />
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Nature of company</label>
                  <select className="uk-select" aria-label="Select">
                    <option value="" selected disabled hidden>
                      Select company type...
                    </option>
                    <option>Option 01</option>
                    <option>Option 02</option>
                  </select>
                </div>
                <div className="uk-width-1-2@m uk-margin">
                  <label>Select country</label>
                  <select className="uk-select" aria-label="Select">
                    <option value="" selected disabled hidden>
                      Select country...
                    </option>
                    <option>Option 01</option>
                    <option>Option 02</option>
                  </select>
                </div>

                <div className="uk-width-1-2@m uk-margin">
                  <label>Select city</label>
                  <select className="uk-select" aria-label="Select">
                    <option value="" selected disabled hidden>
                      Select city...
                    </option>
                    <option>Option 01</option>
                    <option>Option 02</option>
                  </select>
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Postal code</label>
                  <input
                    className="uk-input"
                    type="text"
                    placeholder="Postal code"
                    aria-label="Input"
                  />
                </div>
                <div className="uk-width-1-1@m uk-margin-top">
                  <label>Address</label>
                  <textarea
                    className="uk-textarea"
                    rows="4"
                    placeholder=" Select address ..."
                    aria-label="Textarea"
                  ></textarea>
                </div>

                <div className="uk-width-1-1@m uk-float-right uk-margin-top">
                  <div className="formActionBtn uk-text-right">
                    <button className="whiteBtn">Cancel</button>
                    <button className="pinkBtn">Save</button>
                  </div>
                </div>
              </div>
            </div>
          </form> */}
        </div>
      </div>
    </div>
  );
};

export default EditDetailForm;
